import { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/pro-light-svg-icons";
import { useSectionNavigationContext } from "../section-navigation-context";
import { SectionNavigationToggleProps } from "./interfaces";

const SectionNavigationToggle: FC<SectionNavigationToggleProps> = ({
  index,
  className,
  icon,
  id,
  ...rest
}) => {
  const { getToggleProps, isFlat } = useSectionNavigationContext();

  if (!getToggleProps) {
    throw new Error(
      "SectionNavigation.Toggle component requires getToggleProps to be defined",
    );
  }

  if (isFlat) {
    return null;
  }

  const toggleIcon = icon ? icon : faAngleDown;

  return (
    <button {...getToggleProps({ index, id, className, ...rest })}>
      <FontAwesomeIcon
        className="eb-section-nav__toggle-icon"
        icon={toggleIcon}
      />
    </button>
  );
};

export default SectionNavigationToggle;
